<template>
  <div>
      <div >
        <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">雇主险出险-详情</div>
        <el-button style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Return">返回</el-button>

        <!-- 主体 -->
    <div style="height:540px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
      <!-- 查询框 -->
      <span style="color:#006E4B;font-weight:900;font-size:20px">|   </span>
      <span style="font-size:20px;font-weight:700">人员信息</span>
      <div style="border:1px solid #DADADA;margin-top:10px"></div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm"> 
            <el-row>
                <el-col :span="6">
                <el-form-item label="姓名" prop="name" style="margin-top:40px">
                    {{$parent.ruleForm.staff_name}}
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="身份证号" prop="name" style="margin-top:40px">
                    {{$parent.ruleForm.staff_card}}
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="手机号" prop="name" style="margin-top:40px">
                    {{$parent.ruleForm.staff_telephone}}
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="性别" prop="name" style="margin-top:40px">
                    {{$parent.ruleForm.staff_gender === "1"?"男":"女"}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6">
                <el-form-item label="年龄" prop="name">
               {{$parent.ruleForm.staff_age}}
                </el-form-item>
                </el-col>
				<el-col :span="6">
				<el-form-item label="岗位" prop="name" style="width:80%">
				  {{$parent.ruleForm.post_name}}
				</el-form-item>
				</el-col>
                <el-col :span="6">
                <el-form-item label="城市" prop="name">
                {{$parent.ruleForm.city_id}}
                </el-form-item>
                </el-col>
            </el-row>
			<el-row>
				<el-col :span="24">
				<el-form-item label="组织架构" prop="name">
				{{$parent.ruleForm.range}}
				</el-form-item>
				</el-col>
			</el-row>

        <div style="margin-top:50px;">
                <span style="color:#006E4B;font-weight:900;font-size:20px;">|   </span>
                <span style="font-size:20px;font-weight:700">出险信息</span>
                <div style="border:1px solid #DADADA;margin-top:10px"></div>

            <el-row style="margin-left:120px">
                <el-row>
                <el-col>
                <el-form-item label="出险时间" prop="name" style="margin-top:50px">
                  {{$parent.ruleForm.danger_dete}}
                </el-form-item>
                </el-col>

            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="出险经过" prop="name">
                {{$parent.ruleForm.danger_after}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="事故照片" prop="name">
                    <img src="$parent.ruleForm.accident_photo">
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="报案号" prop="name" style="width:80%">
                  {{$parent.ruleForm.report_no}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="保单号" prop="name" style="width:80%">
                  {{$parent.ruleForm.policy_no}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="理赔情况" prop="region" >
                   {{  $parent.ruleForm.settlement_status == '0' ?  '未理赔':
                   ($parent.ruleForm.settlement_status == '1' ?  '已理赔' : '已撤案' )  }}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="医疗票据" prop="region" >
                   <img src="$parent.ruleForm.bill_url">
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="收保险公司理赔款" prop="region" >
                   {{$parent.ruleForm.settlement_amount}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="付员工理赔款" prop="region" >
                   {{$parent.ruleForm.indemnity_amount}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="结案日期" prop="region" >
                   {{$parent.ruleForm.close_date}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                <el-form-item label="情况备注" prop="region" >
                   {{$parent.ruleForm.remarks}}
                </el-form-item>
                </el-col>
            </el-row>
            </el-row>
        </div>
        </el-form>

      </div>
      
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        ruleForm: {
          id:'',
          company_id:'',
          staff_id:'',
          staff_name:'',
          staff_card:'',
          staff_telephone:'',
          company_name:'',
          modular_name:'',
          staff_gender:'',
          staff_age:'',
          project_name:'',
          city_id:'',
          post_name:'',
          danger_dete:'',
          danger_after:'',
          report_no:'',
          policy_no:'',
          settlement_amount:'',
          indemnity_amount:'',
          close_date:'',
          remarks:'',
          bill_url:'',
          settlement_status:'',
          accident_photo:[],
          type: [], 
        },
      };
    },
    methods: {
      Return(){
        this.$parent.Return();
      }
    },
    created() {
    this.ruleForm = this.$parent.ruleForm;
    },
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Gzxcx_edit.vue?b659a100